import confirmPage from './confirmTip.vue';

const confirmTip = {
    install: function(Vue) {
        Vue.component('confirmTip', confirmPage)
    }
}

export default confirmTip;